
import {Constants,ArrayUtil} from '../Constants';
import { CoordGeodetic } from '../../service/coord-helper.service';
import { FdmPlugin, FdmPluginInterface } from './plugins';
import { A, STATE, TURN } from '../States';
import { XsPropsible } from '@src/app/xs/utilities/propsible.class';
import { XsColorStore } from '@src/app/xs/controllers/color-store.class';
import { XsAwait } from '@src/app/xs/controllers/await.class';
import { XsDefaults } from '@src/app/xs/utilities/defaults.class';
import { XsPropsicle } from '@src/app/xs/utilities/propsicle.class';
import { Observable } from 'rxjs';
import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';


import * as _ from 'lodash';
import { KeyValue } from '@angular/common';
const Cesium = (<any>window).Cesium;

export class ColorizingHandler extends FdmPlugin implements FdmPluginInterface {

    debug:boolean = Constants.debug_off;
    debugAndApply:boolean = true;

    static meta = {
        label: 'PLUGINS.COLORIZER.LABEL',
        name: 'colorizing-handler',
        translator: 'PLUGINS.COLORIZER',
        tooltip: 'PLUGINS.COLORIZER.TOOLTIP', 
        
        // monitor a shortcut for this plugin
        shortcut: true,
        icon: 'paint-brush',
        plugsAsTabs:true,
        
        category: FdmPlugin.category.generic,
        types: [ FdmPlugin.types.transformController ],

        // we service laslaz/laslaz_tiles (pointclouds) and tms (terrain models)
        ds_types: [ FdmPlugin.ds_types.tms, FdmPlugin.ds_types.dxf, FdmPlugin.ds_types.laslaz, FdmPlugin.ds_types.laslaz_tiles, FdmPlugin.ds_types.three_d_tiles, FdmPlugin.ds_types.obj, FdmPlugin.ds_types.public_3d, FdmPlugin.ds_types.shape_zip, FdmPlugin.ds_types.e57 ],

        // Transform type
        tr_types: [ FdmPlugin.tr_types.three_d_tiles,FdmPlugin.tr_types.public_3d, FdmPlugin.tr_types.terrain_tiles ],
        
        // One per item
        cardinality: FdmPlugin.cardinality.one,
    };

    // Controls
    controls:any = {
        show:  { value:true, type:'check', info:'' },
        mimainfo: { type:'info', value:'', feature:'minmax' },

        // legend:  { value:false, name:'Show legend', type:'check', plugConfig:'legend-handler' },
        // labels:  { value:false, name:'Show labels', type:'check', plugConfig:'labels-handler', group:'advanced' },

        colorMode: { value:'REPLACE', type:'radio', options: ['REPLACE','MIX','HIGHLIGHT'], translateOptions:true },
        
        property: { value: 'none', type:'select', noshow:true, options: ['none'], translateOptions:false, adjust:'minmax', feature:'property', topSpace:true },
        propertyType: { value:'', type:'info', noshow:true, zfeature:'property' },
        propertyLength: { value:'none', options: ['none'], translateOptions:false, noshow:true, type:'info', zfeature:'property' },
        propertyInfo: { value:0, options: ['none'], translateOptions:false, type:'info', noshow:true, feature:'property' },
        propertyMode: { value:'colormap', type:'radio', options: ['colormap','valuecheck'], translateOptions:true, noshow:true, feature:'property' },
        propertyMap: { value:{}, type:'button', icon:'cog', action:'clickColorMap', noshow:true, feature:'property' },
        
        max: { value:8777, type:'number', min: -414, max:8777, step:1, modelValue:0, noshow:true, feature:'zminmax' },
        min: { value:-414, type:'number',  min: -414, max:8777, step:1, modelValue:0, noshow:true, feature:'zminmax' },
        mima: { type:'range', value:null, from:40, fromPost:'m', to:360, toPost:'m', min:30, max:440, step:1, noshow:true, feature:'minmax', topSpace:true },
        mimaActions: { value:'normal', type:'actions', icons: [ ['original','undo','MIMAACTION_RESET'],['from_property','expand-alt','MIMAACTION_PROPERTY'], [ 'sample_view', 'eye-dropper','MIMAACTION_SAMPLE' ] ], feature:'minmax' },
        bounds: { value:false, type:'check', feature:'minmax' },
        boundsColor: { value:'#ccaabb', type:'color', noshow:true },
        boundsMaxColor: { value:'#bbccaa', type:'color', noshow:true, feature:'minmax' },
        boundsMinColor: { value:'#aabbcc', type:'color', noshow:true, feature:'minmax' },
        
        resetHeight: { type:'button', action:'resetHeight', noshow:true, style:'accent', feature:'zminmax' },
        beam: { type:'button', action:'sampleHeight', noshow:true, style:'primary', feature:'zminmax' },

        shader: { value: 'elevation', type:'radio', oldValue:null, options:[ 'elevation', 'slope', 'aspect' ], translateOptions:true, noshow:true, feature:'shader', topSpace:true },
        rampHeight: { value:1, type:'slider', min:1, max:1, step:1, canvas: null, noshow:true, feature:'zshader' },
        rampWidth: { value:100, type:'slider', min:1, max:4000, step:1, noshow:true, feature:'zshader' },

        contour:  { value:false, type:'check', noshow:true, feature:'contour', topSpace:true },
        contourColor: { value:'#cc0', type:'color', noshow:true, feature:'contouring' },
        contourHeight: { value:10, type:'slider', min:0.01, max:50, step:0.01, noshow:true, feature:'contouring' },
        contourWidth: { value:2, type:'slider', min:1, max:10, step:1, noshow:true, feature:'contouring' },

        kind: { value: 'default', type:'select', options: [ 'none' ], translateOptions:true, optionType:'colors', colorbar:true, topSpace:true, feature:'color' },
        kindOrder: { value:'normal', type:'actions', icons: [ ['normal','undo'],['reverse','arrows-alt-v'],['random','random'] ], feature:'color' },
        opacity: { value:0, type:'slider', min:0.02, max:1, step:0.01, noshow:true, feature:'color'  },
        threshold: { value:50, type:'slider', min:1, max:100, step:1, valueWidth:40, valuePost:'%', noshow:true, feature:'threshold' },
        thresholdtype: { value:false, type:'check', noshow:true, feature:'threshold' },

        lighting: { value:false, type:'check', group:'advanced' },
        
        debug: { value:'', type:'info', noshow:true }
    }

    show:boolean = false;

    // plugin specific things
    globe:any = null;
    viewer:any = null;

    // static types we support
    static TerrainType:string = 'terrain';
    static PointcloudType:string = 'pointcloud';
    static ThreedType:string = 'three-d-tiles';

    // current type for this plugin/transform
    type:string = null;

    // pre-made color schemes, for faster access to color bands
    preMadeColors:any = {};
    currentColors:any = {};

    // terrain specific uniforms (material modifiers)
    shadingUniforms:any = {};
    contourUniforms:any = {};

    // terrain compund; '' (none), 'contour', 'contour-elevation', 'contour-slope'
    // currentCompound:string = '';

    // elevationRamp = [0.0, 0.025, 0.05, 0.075, 0.1, 0.15, 0.2, 0.25, 0.35, 0.45, 0.55, .6, .65, .7, .75, .8, .85, .9, .95, 1.0];
    

    // states
    hasColorFile:boolean = false;
    hasHeightFile:boolean = false;
    hasColorProperties:boolean = false;

    initialGlobeLighting:boolean = false;

    coordHelper:any = null;
    mapService:any = null;
    // sceneController:any = null;

    streamedPropertyStore:XsPropsible = new XsPropsible();

    properties:XsPropsicle = null;

    // create a color store / cache with a reference to our controls
    colorStore:XsColorStore = new XsColorStore({ controls: this.controls, colorManager: this.services.colorManager });

    // propertiesValueMap:any = {};

    // our color store / palette
    colors:any[] = null;

    defaults:XsDefaults = new XsDefaults({ items: ['paletteLut','colorizeRules'] });


    // for tilesets that stream property values (end is when all in the queue or at reasonable intervals are loaded)
    ___tilesLoadingEnd ( incomingData:any = null ) {

        // more tiles have finished loading, so check if there's more properties
        XsAwait.until( 'streamedPropertyStore', this ).then ( _ => {

            // NOTE : Convert the below into XsPropsicle instead
            this.streamedPropertyStore.populate( this.item['__properties'] );

            // also update the controls / info every time we get to an end of sorts
            // if ( this.controls.property.value !== '' && this.controls.property.value !== 'none' ) {
                this.configProperty(this.controls.property.value);
            // }

            // this.controls.property.options = this.propertyStore.getPropertyNames();
            // console.log('@@COLORIZER interval props -------------- ', this.streamedPropertyStore ); 

        });
    }

    // when the plugin is deleted from an item, do some cleanup
    deleting() {
        this.item['__propertiesStreaming'] = false;
    }

    // when the Transform object is injected
    itemInjected() {

        // console.log ( '%c colorize.plugin %c itemInjected()', this.debugPrimary, this.debugSecondary, this.item );

        // half-time fetch some data to get going
        // NOTE : Only for 3DTiles that aren't pointclouds
        setTimeout ( () => { this.___tilesLoadingEnd(); }, 2000 );

        // defaults fetches first time load values
        this.defaults.readFromItem ( this.item );
    }


    // when the Cesium object is injected
    objectInjected () {

        // shortcuts
        this.mapService = this.services.mapService;
        this.coordHelper = this.services.coordHelper;

        // first time, so create all default color palettes
        this.controls.kind.options = this.services.colorManager.listColorPalettes();

        // we've overridden this, but we want to do some default stuff
        super.objectInjected ();

        this.finalisers.push( () => this.showHide( false ) );

        this.properties = new XsPropsicle({ items: [ this.object ] });

        // console.log ( '%c colorize.plugin %c objectInjected()', this.debugPrimary, this.debugSecondary, this.object, this.props );
        
        this.updatePropertyNames();

        // console.log ( '%c colorize.plugin %c objectinjected() PROPS', this.debugPrimary, this.debugSecondary, this.props );


        // setTimeout ( ()=>{ this.listProperties(); }, 5000 );

        /* this.controls['minmax'] = { name:'Height', type:'compound', items: [
            { reference:'min' },
            { reference:'max' },
            { reference:'beam' },
            { reference:'resetHeight'}, 
        ]}; */

        /* this.controls['contours'] = { type: 'compound', noshow:true, items: [
            { reference:'contourColor' },
            { reference:'contourHeight' },
            { reference:'contourWidth' }
        ]}; */

        this.viewer = this.mapService.viewer;
        this.globe = this.viewer.scene.globe;


        // height file
        this.mapService.getTransformHeightFile(this.item).subscribe(s => {
            if ( this.debug ) { console.log ( '%c colorize.plugin %c objectinjected() HEIGHT file', this.debugPrimary, this.debugSecondary, this.item, s ); }
            if (s) {
                this.hasHeightFile = true;
                try {
                    // "-5.73702049255,29.3271980286"
                    var minMax = s.split(',');
                    if ( this.controls.min.value == -414 ) { this.controls.min.value = +((+minMax[0]).toFixed(2)); }
                    if ( this.controls.max.value == 8777 ) { this.controls.max.value = +((+minMax[1]).toFixed(2)); }
                    this.setModelMinMax();
                    this.refresh();
                } catch (e) {
                    // this.setMinMaxHeightFromTransform();
                }
            }
        }, error1 => {
            if ( this.object instanceof Cesium.CesiumTerrainProvider ) {
                this.controls['note'] = { value:this.meta.translator+'.ERROR', type: 'note' };
                // console.log('!!! no HEIGHT file', this.item['ds_type_uid'] );
            }
        });


        // color file
        this.mapService.getTransformColorFile(this.item).subscribe(s => {
            if ( this.debug ) { console.log ( '%c colorize.plugin %c objectInjected() COLOR file', this.debugPrimary, this.debugSecondary, this.item, s ); }
            if (s) {
                this.hasColorFile = true;
                this.refresh();
            }
        }, error1 => {
            if ( this.object instanceof Cesium.CesiumTerrainProvider ) {
            } else {
                if ( this.item && this.item.__check_feature('isPointCloud') ) {
                    this.controls['note'] = { value:this.meta.translator+'.ERROR_COLOR', type: 'note' };
                }
            }
        });


        // it's either a terrain model
        if ( this.object instanceof Cesium.CesiumTerrainProvider ) {

            // console.log('###Terrain');

            // default opacity for terrain
            if ( this.controls.opacity.value === 0 ) { this.controls.opacity.value = 0.6; }

            this.type = ColorizingHandler.TerrainType;


        // or it's a 3D tileset ...
        } else if ( this.object instanceof Cesium.Cesium3DTileset ) {

            // basic 3D tileset
            this.type = ColorizingHandler.ThreedType;

            // default opacity for 3DTiles
            if ( this.controls.opacity.value === 0 ) { this.controls.opacity.value = 0.6; }

            // or it's a pointcloud
            if ( this.item && this.item.__check_feature('isPointCloud') ) {
                this.type = ColorizingHandler.PointcloudType;

                // default opacity for pointclouds
                if ( this.controls.opacity.value === 0 ) { this.controls.opacity.value = 1; }

                // console.log('###3DTiles PointCloud');
                /*
                this.controls.propertyType.value = 'number';
                this.controls.propertyMode.value = 'valuecheck'
                this.controls.propertyLength.value = 0;
                this.turnOnFeatures([ 'threshold' ]);
                this.turnOn(['minmax']);
                */
            } else {
                // console.log('###3DTiles tileset');

                // only for 3DTilesets (not pointclouds or terrains); are we streaming properties?
                if ( !this.item['__propertiesStreaming'] ) {
                    
                    // no? We'll turn them on, because colorizing needs it
                    this.item['__propertiesStreaming'] = true;

                    // console.log('###3DTiles tileset STARTING streaming');

                    this.object.show = false;

                    // streaming usually means we need to "reset" or start the streaming again
                    this.services.featureDetector.__gs( this.item, {} , { object:this.object }).then ( _ => {

                        // console.log('###3DTiles tileset STREAMING INIT');
                        this.object.trimLoadedTiles();

                        setTimeout( () => {
                            this.object.show = true;
                            // console.log('###3DTiles tileset STREAMING STARTED');
                        }, 500 );

                        
                    
                    });
                } else {
                    // console.log('###3DTiles tileset ALREADY streaming');
                }
            }
        
            let happy:boolean = false;

            if ( this.controls.min.value == -414 && this.controls.max.value == 8777 ) {
                happy = this.getObjectMinMax();
            }

        } else {
            console.error('UNKNOWN', typeof this.object );
        }

        this.controls.show.info = (''+this.type).toUpperCase();

        if (this.item['minHeight'] && this.controls.min.value == -414 ) {
            this.controls.min.value = Math.round(+this.item['minHeight']);
        }
        if (this.item['maxHeight'] && this.controls.max.value == 8777 ) {
            this.controls.max.value = Math.round(+this.item['maxHeight']);
        }
        this.setModelMinMax();

        if ( this.debug ) { console.log ( '%c colorize.plugin %c objectInjected() FEATURES', this.debugPrimary, this.debugSecondary, this.type, this.controls, this.object ); }

    }

    end() {

        // report to sceneController that we've turned off this one's transparency

        if ( this.type == ColorizingHandler.PointcloudType || this.type == ColorizingHandler.ThreedType ) {

            this.services.sceneController.report ( '_'+this.item.id, A.TRANSPARENT_ITEM, STATE.NO );

        } else if ( this.type == ColorizingHandler.TerrainType ) {

            this.services.sceneController.report ( '_'+this.item.id, A.TRANSPARENT_TERRAIN, TURN.OFF );
        }

        this.updatePlug ('legend-handler', null );
        this.updatePlug ('labels-handler', null );

        delete this.properties;
        delete this.streamedPropertyStore;

        // console.log('@@COLORIZING end() DONE' );
    }

    setModelMinMax ( original:boolean = true ) {

        // console.log('## MIN_MAX', original, this.controls.mima.value );

        if ( typeof this.controls.mima.value == 'object' && this.controls.mima.value && this.controls.mima.value.from ) {
            this.controls.min.value = this.controls.mima.value.from;
            this.controls.max.value = this.controls.mima.value.to;
            // console.log('## MIN_MAX RESTORED', this.controls.mima.value );
            this.controls.mima.value = null;
        }

        // set the range
        this.controls.mimainfo.value = this.type.toUpperCase() + ' from '+this.controls.min.modelValue+'m to '+ this.controls.max.modelValue+'m';
        this.controls.mima.from = this.controls.min.value;
        this.controls.mima.to = this.controls.max.value;

        // not sure these two are needed
        if ( original ) {
            this.controls.min.modelValue = this.controls.min.value;
            this.controls.max.modelValue = this.controls.max.value;
        } else {
            this.controls.mima.value = { from: this.controls.mima.from, to: this.controls.mima.to };
            // console.log('## MIN_MAX SAVED', this.controls.mima.value );
        }
        
    }




    refresh( newvalue = null, section:any = null ) {

        // check in with mama
        super.refresh ( newvalue, section );
        
        if ( this.show !== this.controls.show.value ) {
            this.show = this.controls.show.value;
        }
        /* if ( section && section.adjust && section.adjust == 'minmax' ) {

            let minmax = this.getMinMaxFor ( this.controls.property.value );

            this.controls.min.value = minmax.min;
            this.controls.max.value = minmax.max;

            this.controls.threshold.min = minmax.min;
            this.controls.threshold.max = minmax.max;
        } */

        if ( 
            ( this.type == ColorizingHandler.PointcloudType ) 
            ||
            ( this.type == ColorizingHandler.TerrainType )
            ||
            ( this.type == ColorizingHandler.ThreedType )
        ) {
            this.showHide();
        }
    }

    getCurrentColors( forcedNew:boolean = false ) {
        if ( forcedNew ) {
            this.colorStore.resetColor();
        }
        if ( this.controls.propertyLength.value !== 'none' && this.controls.propertyLength.value !== 0 ) {
            this.colors = this.colorStore.getColors( null, this.controls.propertyLength.value ); // this.services.colorManager.getColors( this.controls.kind.value, { items: this.controls.propertyLength.value, order:this.controls.kindOrder.value, debug:'3DTiles' } );
        } else {
            this.colors = this.colorStore.getColors(); // default is current kind (color palette name) and 100 resolution
        }
    }

    // simple UI checker for bounds, in own function as we're using it in different places
    checkBounds() {
        if ( this.controls.propertyMode.value == 'valuecheck' ) {
            this.turnOn(['bounds']);
            if ( this.controls.bounds.value ) {
                this.turnOn(['boundsMinColor','boundsMaxColor']);
            } else {
                this.turnOff(['boundsMinColor','boundsMaxColor']);
            }
        } else {
            this.turnOff(['bounds','boundsMinColor','boundsMaxColor']);
        }
    }

    // overriding, using it as a start/stop mechanism
    showHide( state:boolean = this.show ) {

        // console.log("######### REFRESH");

        // new state
        this.show = state;

        // to avoid some 'this' spaghetti
        // let me = this;

        // return;

        const isColorizing = this.controls.show.value;
        const hasColors = this.controls.kind.value == 'none' ? false : true;
        // const showColors = this.type !== ColorizingHandler.ThreedType ? true : false;
        // const showProperty = this.type == ColorizingHandler.ThreedType ? true : false;
        // const hasProperty = this.controls.property.value == 'none' ? false : true;
        
        const isStriped = ( this.controls.kind.value == 'stripe' || this.controls.kind.value == 'split' ) ? true : false;
        
        // start
        if ( this.show ) {

            let hasContour = this.controls.contour.value;
            let shader = this.controls.shader.value;
            let material = null;

            this.controls.debug.value = 'contour='+hasContour+' color='+hasColors+' shader='+shader;

            this.globe.enableLighting = this.controls.lighting.value;

            this.startCalculating(100);

            // whatever entity we're colorizing
            if ( this.object ) {

                this.updateCalculationProcess(10);

                // find out what the type of a property is
                if ( this.controls.property.value !== '' && this.controls.property.value !== 'none' ) {
                    this.configProperty(this.controls.property.value);
                }

                // default color fetch mode is the length of the property selected
                this.getCurrentColors(isStriped);

                this.updateCalculationProcess(20);

                // have we fetched any default values coming in? (from last time they saved and used the colorising)
                if ( !this.defaults.isFetched('paletteLut') && this.defaults.hasValue('paletteLut') ) {

                    const lut = this.defaults.fetch('paletteLut');
                    this.colorStore.setPaletteLut ( null, lut );
                    // console.log("@MANAGE@ INCOMING_DEFAULT_PALETTE", lut, this.defaults.fetch('paletteLut',true) );

                    // redo the colors with the new palette LUT
                    this.getCurrentColors();
                }

                // clear the CSS cache of colors (as we do a new render cycle)
                this.preMadeColors = {};

                this.defaults.put( 'paletteLut', this.colorStore.getPaletteLut(null) ); // null means get default or whatever is currently selected


                if ( this.type == ColorizingHandler.TerrainType || this.type == ColorizingHandler.PointcloudType ) {
                    this.turnOff(['colorMode']);
                } else {
                    this.turnOn(['colorMode']);
                    switch ( this.controls.colorMode.value ) {
                        case 'HIGHLIGHT': this.object.colorBlendMode = Cesium.Cesium3DTileColorBlendMode.HIGHLIGHT; break;
                        case 'REPLACE': this.object.colorBlendMode = Cesium.Cesium3DTileColorBlendMode.REPLACE; break;
                        case 'MIX': this.object.colorBlendMode = Cesium.Cesium3DTileColorBlendMode.MIX; break;
                    }
                    this.object.makeStyleDirty();
                    // console.log('## color blend', this.controls.colorMode.value, this.object.colorBlendMode );
                }
                
                

                this.controls.min.value = this.controls.mima.from;
                this.controls.max.value = this.controls.mima.to;

                this.updateCalculationProcess(30);

                if ( this.type == ColorizingHandler.PointcloudType || this.type == ColorizingHandler.TerrainType ) {

                    // point clouds currently only support 'Height' property until we figure out a good way
                    // to either put in good properties, or pull out. The UI can't do either, so we need
                    // some better backend way to do it, for example put it into the colors.txt file

                    this.controls.property.value = 'Height';
                    this.controls.propertyType.value = 'number';
                    this.controls.propertyMode.value = 'valuecheck'
                    this.controls.propertyMode.noshow = true;
                    this.controls.propertyLength.value = 0;

                    this.turnOnFeatures([ 'minmax','color' ]);
                    this.turnOffFeatures([ 'property' ]);
                    this.turnOff(['propertyMap']);

                    this.controls.mimaActions.icons = [ ['original','undo'], [ 'sample_view', 'eye-dropper' ] ];

                } else if ( this.type == ColorizingHandler.ThreedType ) {

                    this.controls.mimaActions.icons = [ ['original','undo'],['from_property','expand-alt'], [ 'sample_view', 'eye-dropper' ] ];

                    this.turnOnFeatures([ 'property' ]);

                    if ( this.controls.propertyMode.value == 'valuecheck' ) {
                        this.turnOnFeatures([ 'minmax','color' ]);
                        this.turnOff(['propertyMap']);
                    } else {
                        this.turnOffFeatures([ 'minmax','color' ]);
                        this.turnOn(['propertyMap']);
                    }

                    if ( this.controls.propertyType.value == 'string' ) {
                        this.controls.propertyMode.value = 'colormap';
                        this.controls.propertyMode.noshow = true;
                    } else {
                        this.controls.propertyMode.noshow = false;
                    }
                }

                // all types

                if ( this.controls.propertyMode.value == 'valuecheck' ) {

                    // console.log('#valuecheck');
                    this.turnOff(['propertyMap']);
                    
                    // if we have color selected or not, show or hide opacity slider and color order buttons
                    if ( hasColors ) {
                        this.turnOn(['opacity','kindOrder']);
                        //this.controls.opacity.noshow = false;
                        //this.controls.kindOrder.noshow = false;
                    } else {
                        this.turnOff(['opacity','kindOrder']);
                        //this.controls.opacity.noshow = true;
                        //this.controls.kindOrder.noshow = true;
                    }

                    // applies to all types
                    if ( isStriped && hasColors ) {

                        this.turnOnFeatures([ 'threshold' ]);

                        if ( this.controls.thresholdtype.value ) {
                            // absolute value
                            this.controls.threshold.min = this.controls.min.value;
                            this.controls.threshold.max = this.controls.max.value;
                            this.controls.threshold.step = 0.25;
                            this.controls.threshold.valuePost = null;
                            if ( this.controls.threshold.value > this.controls.max.value || this.controls.threshold.value < this.controls.min.value ) {
                                this.controls.threshold.value = ( this.controls.max.value - this.controls.min.value ) / 2;
                            }
                        } else {
                            // percent value
                            this.controls.threshold.min = 0.1;
                            this.controls.threshold.max = 100;
                            this.controls.threshold.step = 1;
                            this.controls.threshold.valuePost = '%';
                            if ( this.controls.threshold.value > 100 || this.controls.threshold.value < 0.2 ) {
                                this.controls.threshold.value = 50;
                            }
                        }
                    } else {
                        this.turnOffFeatures([ 'threshold' ]);
                    }

                } else {
                    // console.log('#colormap');
                    this.turnOffFeatures([ 'threshold','color' ]);
                    this.turnOn(['propertyMap']);

                    if ( this.controls.property.value == '' || this.controls.property.value == null || this.controls.property.value == undefined ) {
                        this.controls.property.value == 'none';
                    }
                }

                this.checkBounds();
                
                this.turnOff(['contour']);

                this.updateCalculationProcess(40);

                // render color for specific types

                if ( this.type == ColorizingHandler.ThreedType ) {

                    if ( this.controls.kind.value !== 'none' && this.controls.property.value !== 'none' ) {

                        const render = this.renderColors();

                        let style = {
                           defines: {
                             "MinHeight" : this.controls.min.value,
                             "MaxHeight" : this.controls.max.value,
                             "Attribute" : "${"+this.controls.property.value+"}"
                           },
                           color: {
                              conditions: render.colors
                           },
                        };

                        if ( !this.defaults.isFetched('colorizeRules') && this.defaults.hasValue('colorizeRules') ) {
                            style = this.defaults.fetch('colorizeRules');
                            // console.log("@MANAGE@ INCOMING_DEFAULT_STYLE", this.defaults.fetch('colorizeRules',true) );
                        }
                        this.defaults.put( 'colorizeRules', style );

                        this.updateCalculationProcess(60);

                        if ( this.debugAndApply ) {
                            // this.__log('RENDER 3D TILESET', [style,this.object] );
                            if ( ! _.isEqual ( render.colors, this.currentColors ) ) {
                                this.currentColors = render.colors;
                                this.services.sceneController.reportComplexAction ( 'colorizer::render-colors::3-d-tiles', { transformId:this.item.id, render:render });
                                this.object.style = new Cesium.Cesium3DTileStyle( style );
                                this.updateCalculationProcess(90);
                            }
                        }
                        if ( this.debug ) { 
                            console.log ( '@@@@@@@@@@@@@@@@@@@@@@@@@@', this.controls.property.value, style, this.object ); 
                        }

                    } else {
                        if ( this.debugAndApply ) { this.object.style = new Cesium.Cesium3DTileStyle(); }
                        if ( this.debug ) { console.log ( '######################', this.controls.property.value ); }
                    }

                } else if ( this.type == ColorizingHandler.PointcloudType ) {

                    if ( this.debug ) { console.log('!!! colorizePointcloud() INIT'); }

                    if ( this.controls.kind.value !== 'none' && this.controls.property.value !== 'none' ) {

                        if ( this.debug ) { console.log('!!! colorizePointcloud() COLORS', this.colors ); }

                        const render = this.renderColors();

                        let style = {
                            defines: {
                                "MinHeight" : this.controls.min.value,
                                "MaxHeight" : this.controls.max.value,
                                "Attribute" : "${"+this.controls.property.value+"}"
                            },
                            color: {
                                conditions: render.colors
                            }
                        };

                        this.updateCalculationProcess(60);

                        if ( !this.defaults.isFetched('colorizeRules') && this.defaults.hasValue('colorizeRules') ) {
                            style = this.defaults.fetch('colorizeRules');
                            // console.log("@MANAGE@ INCOMING_DEFAULT_STYLE", this.defaults.fetch('colorizeRules') );
                        }
                        this.defaults.put( 'colorizeRules', style );

                        // let pos = this.mapService.viewer.camera.position;

                        /*
                        let config = {
                            defines: {
                                distance: 'clamp( distance( ${POSITION_ABSOLUTE}, vec3('+pos.x+','+pos.y+','+pos.z+') ) / 250.0, 0.0, 1.0)'
                            },
                            color: 'mix(color("yellow"), color("red"), ${distance})'
                        }; */
                        // setTimeout( () => { this.exploreObject ( this.object ); }, 8000 );

                        if ( this.debug ) { console.log('!!! colorizePointcloud() START', style ); }

                        if ( this.debugAndApply ) {
                            if ( ! _.isEqual ( render.colors, this.currentColors ) ) {
                                this.currentColors = render.colors;
                                this.services.sceneController.reportComplexAction ( 'colorizer::render-colors::pointcloud', { transformId:this.item.id, render:render });
                                this.object.style = new Cesium.Cesium3DTileStyle( style );
                                this.updateCalculationProcess(90);
                            }
                        }

                        // report to sceneController that we've turned this one transparent
                        this.services.sceneController.report ( '_'+this.item.id, A.TRANSPARENT_ITEM, STATE.YES );

                    } else {

                        if ( this.debugAndApply ) { this.object.style = new Cesium.Cesium3DTileStyle({ color: '${COLOR}' }); }

                        // report to sceneController that this one hasn't been turned transparent yet (no color)
                        this.services.sceneController.report ( '_'+this.item.id, A.TRANSPARENT_ITEM, STATE.NO );
                    }

                } else if ( this.type == ColorizingHandler.TerrainType ) {

                    material = null;

                    this.turnOn(['contour']);

                    if ( hasContour ) {
                        this.turnOnFeatures(['contouring']);
                    } else {
                        this.turnOffFeatures(['contouring']);
                    }

                    // do we do any colors?
                    if ( ! hasColors ) {

                        this.turnOffFeatures(['shader','minmax']);

                        if ( hasContour ) {
                            material = Cesium.Material.fromType('ElevationContour');
                            this.contourUniforms = material.uniforms;
                        }

                        this.services.sceneController.report ( '_'+this.item.id, A.TRANSPARENT_TERRAIN, TURN.OFF );

                    } else {

                        // yes, colors
                        
                        this.turnOnFeatures(['shader','minmax']);
                        this.checkBounds();

                        this.services.sceneController.report ( '_'+this.item.id, A.TRANSPARENT_TERRAIN, TURN.ON );

                        material = hasContour ? this.getContourMaterial( shader ) : this.getMaterial ( shader ); // Cesium.Material.fromType('SlopeRamp');
                        
                        if ( hasContour ) {

                            this.contourUniforms = material.materials.contourMaterial.uniforms;

                            if ( shader == 'elevation' ) {
                                this.shadingUniforms = material.materials.elevationRampMaterial.uniforms;
                            } else if ( shader == 'slope' ) {
                                this.shadingUniforms = material.materials.slopeRampMaterial.uniforms;
                            }

                        } else {
                            if ( material && material.uniforms ) {
                                this.shadingUniforms = material.uniforms;
                            }
                        }

                        // if ( shader == 'elevation' ) {
                            this.shadingUniforms['minimumHeight'] = this.controls.mima.from;
                            this.shadingUniforms['maximumHeight'] = this.controls.mima.to;
                        // }
                        

                        // turn min/max controls into controllables depending
                        if ( shader == 'elevation' ) {
                            this.controls.min.type = 'number';
                            this.controls.max.type = 'number';
                        } else if ( shader == 'slope' ) {
                            this.controls.min.type = 'info';
                            this.controls.max.type = 'info';
                        }

                        this.updateCalculationProcess(60);

                        if ( this.controls.shader.oldValue !== this.controls.shader.value ) {
                            this.controls.shader.oldValue = this.controls.shader.value;
                            if ( this.controls.shader.value == 'elevation' ) {
                                this.controls.lighting.value = false;
                            } else {
                                this.controls.lighting.value = true;
                            }
                            this.globe.enableLighting = this.controls.lighting.value;
                        }
                        
                        const render = this.renderColors( null, 'image' );
                        
                        this.updateCalculationProcess(75);

                        this.globe.material = material;

                        if ( ! _.isEqual ( render.colors, this.currentColors ) ) {

                            this.currentColors = render.colors;
                            this.services.sceneController.reportComplexAction ( 'colorizer::render-colors::terrain', { transformId:this.item.id, render:render });
                            
                            // create an image of the colors, and inject it into the material
                            this.shadingUniforms['image'] = render.colors;
                        }

                        this.updateCalculationProcess(90);

                        // this.controls.rampHeight.canvas = colors;

                        // console.log ( '@@@@@@ shadingUniforms', this.shadingUniforms );
                    
                    }
                    
                    if ( hasContour == true ) {
                        this.contourUniforms['width'] = this.controls.contourWidth.value;
                        this.contourUniforms['spacing'] = this.controls.contourHeight.value;
                        this.contourUniforms['color'] = Cesium.Color.fromCssColorString(this.controls.contourColor.value);
                    }

                    this.globe.material = material;
                    // console.log('######TERRAIN', shader, material )
                }

                this.defaults.writeToItem ( this.item );

                if ( this.debug ) { console.log ( '%c colorize.plugin %c showHide() found object', this.debugPrimary, this.debugSecondary, this.type, hasColors, hasContour, shader, material ); }
                
            }

        // stop
        } else {

            if ( this.type == ColorizingHandler.PointcloudType ) {

                // reset colors
                if ( this.debugAndApply ) { this.object.style = new Cesium.Cesium3DTileStyle({ color: '${COLOR}' }); }

            } else if ( this.type == ColorizingHandler.TerrainType ) {

                this.globe.material = undefined;

            } else if ( this.type == ColorizingHandler.ThreedType ) {

                if ( this.debugAndApply ) { this.object.style = new Cesium.Cesium3DTileStyle(); }

            }

            // turn off lighting if on
            this.globe.enableLighting = this.initialGlobeLighting;

            if ( this.debug ) { console.log ( '%c colorize.plugin %c showHide() stop', this.debugPrimary, this.debugSecondary, this.show ); }
        }

        // plugs (sub-plugins) tab updates. If Terrain, just disable labels
        this.updatePlug ('labels-handler', this.type == ColorizingHandler.TerrainType ? null : this.convertToPluginProperties() );
        this.updatePlug ('legend-handler', this.convertToPluginProperties() );

        this.updateCalculationProcess(100);

        this.endCalculating();

    }

    // if the user clicks on any buttons or icons in the plugin UI, it comes in here
    incomingAction ( value:any, section:any ) {

        // console.log('!!!!! incomingAction()', value );

        // actions for colors
        if ( value == 'normal') {
            this.colorStore.resetColors();
        } else if ( value == 'reverse' ) {
            this.colorStore.reverseColors();
        } else if ( value == 'random' ) {
            this.colorStore.randomizeColors();
        }

        // actions for min/max
        else if ( value == 'original' ) {
            this.controls.min.value = this.controls.min.modelValue;
            this.controls.max.value = this.controls.max.modelValue;
            this.setModelMinMax(false);
            this.controls.mima.value = null;
        } else if ( value == 'from_property' ) {
            let test = this.properties.getPropertyValues ( this.object, this.streamedPropertyStore, this.controls.property.value );
            if ( test ) {
                let min:number = 9999, max:number = -9999;
                Object.keys(test).forEach ( key => {
                    value = parseInt(key);
                    if ( value < min ) { min = value; }
                    if ( value > max ) { max = value; }
                });
                this.controls.min.value = min;
                this.controls.max.value = max;
                this.controls.mima.value = null;
                this.setModelMinMax(false);
            }
            // console.log('!!!!! incomingAction()', value, test ); // this.props
        } else if ( value == 'sample_view' ) {
            this.sampleHeight();
            this.controls.mima.value = null;
        }

        this.save();
        this.refresh();
    }

    clickColorMap ( section:any ) {
        this.open().subscribe( result => {
            if ( result ) {
                this.controls.propertyMap.value = result.map;
                this.save();
                this.refresh();
            }
        });
    }

    open() : Observable<any> {
        const tmp = new Observable( subscriber => {
            this.openObservable().subscribe(result => {
                subscriber.next(result);
                subscriber.complete();
            });
        });
        return tmp;
    }

    openObservable(): Observable<any> {

        let test = this.properties.getPropertyValues ( this.object, this.streamedPropertyStore, this.controls.property.value );
        
        // console.log('##open_config_colormap START', this.controls.property.value, test, this.controls.propertyMap.value );

        if ( !this.controls.propertyMap.value ) {
            this.controls.propertyMap.value = {};
            // console.log('##open_config_colormap ERROR', this.controls.property.value, this.controls.propertyMap.value );
            // return;
        }

        const old_keys:string[] = this.controls.propertyMap.value ? Object.keys(this.controls.propertyMap.value) : [];
        const current_keys:string[] = test ? Object.keys(test) : [];
        
        if ( old_keys && old_keys.length ) {
            old_keys.forEach ( key => {
                if ( !current_keys.find ( f => f == key ) ) {
                    // console.log('@del',key);
                    delete this.controls.propertyMap.value[key];
                } else {
                    // console.log('@old',key);
                }
            });
        }
        
        if ( current_keys && current_keys.length ) {
            current_keys.forEach ( key => {
                let value = parseInt(key);
                if ( !this.controls.propertyMap.value[key] ) {
                    this.controls.propertyMap.value[key] = { string:key, number:value, color:null };
                    // console.log('@add',key);
                }
            });
        }

        // console.log('##open_config_colormap OPEN', test, this.controls.propertyMap.value );

        let dialogRef = this.services.dialog.open(ColormapDialog, {
            width: '50%',
            height: '80%',
            data: {title: 'PLUGINS.COLORIZER.COLORMAP_DIALOG_TITLE', map:this.controls.propertyMap.value, colorManager:this.services.colorManager, plugin:this }
        });
        return dialogRef.afterClosed();
    }



    fetchControlValues ( these:string[] = [] ) {
        let ret = {};
        these.forEach ( key => {
            // todo: parse incoming tokens into object key/value pairs
        });
        return ret;
    }

    convertToPluginProperties() {
        // return this.fetchControlValues(['type=kind','min=mima.from','max=mima.to','attributes=property','attributeType=propertyType']);
        return {
            type: this.controls.kind.value,
            min: Math.round(this.controls.mima.from),
            max: Math.round(this.controls.mima.to),
            attributes: this.controls.property.options,
            attribute: this.controls.property.value,
            attributeType:this.controls.propertyType.value,
            attributeLength: this.controls.propertyLength.value,
            attributeRenderMode: this.controls.propertyMode.value,
            attributeMap: this.controls.propertyMap.value,
            opacity: this.controls.opacity.value,
            threshold: this.controls.threshold.value,
            thresholdType: this.controls.thresholdtype.value,
            thresholdAbsolute: this.controls.thresholdtype.value,
            order: this.controls.kindOrder.value,
            shader: this.controls.shader.value,
            bounds:this.controls.bounds.value,
            boundsColor: this.controls.boundsColor.value,
            boundsMinColor: this.controls.boundsMinColor.value,
            boundsMaxColor: this.controls.boundsMaxColor.value
        }
    }

    renderColors ( name:string = null, type:string = 'cesium', colors:any = null ) {
        let theseColors = colors;
        if ( !colors ) {
            let resolution = this.controls.propertyLength.value; // default for type='cesium' is the property unique values
            if ( type == 'css' || type == 'image' ) {
                resolution = 100; // css and image
            } else if ( type == 'css-vertical' ) {
                resolution = 200; // css-vertical is for legends
            }
            theseColors = this.colorStore.getColors( name, resolution );
        }
        const config = {
            incomingName: name, 
            incomingType: type,
            min: Math.round(this.controls.mima.from),
            max: Math.round(this.controls.mima.to),
            attribute: this.controls.property.value,
            attributeType:this.controls.propertyType.value,
            attributeLength: this.controls.propertyLength.value,
            attributeMap: this.controls.propertyMap.value,
            attributeRenderMode: this.controls.propertyMode.value,
            opacity: this.controls.opacity.value,
            threshold: this.controls.threshold.value,
            thresholdAbsolute: this.controls.thresholdtype.value,
            order: this.controls.kindOrder.value,
            colorName: this.controls.kind.value,
            rampHeight: this.controls.rampHeight.value,
            rampWidth: this.controls.rampWidth.value,
            bounds:this.controls.bounds.value,
            boundsColor: this.controls.boundsColor.value,
            boundsMinColor: this.controls.boundsMinColor.value,
            boundsMaxColor: this.controls.boundsMaxColor.value,
            debug: 'three-d'
        };
        const result = this.services.colorManager.renderColors ( theseColors, type, config );
        return { name:name, type:type, colors:result, config:config };
    }

    linearScalePalette( name:string = 'default' ) {
        // name = this.colorStore.getName(name);
        return this.services.colorManager.getPalette(name);
    }

    linearScale ( name:string = 'default' ) {
        name = this.colorStore.getName(name);
        if ( ! this.preMadeColors.hasOwnProperty ( name ) ) {
            this.preMadeColors[name] = this.renderColors( name, 'css' ).colors;
        }
        return this.preMadeColors[name];
    }

    getMaterial ( type:string = 'elevation' ) {
        let ret = null;
        if ( type == 'elevation' ) {
            ret = Cesium.Material.fromType('ElevationRamp');
        } else if ( type == 'slope' ) {
            ret = Cesium.Material.fromType('SlopeRamp');
        } else if ( type == 'aspect' ) {
            ret = Cesium.Material.fromType("AspectRamp");
        }
        return ret;
    }

    getContourMaterial( type:string = 'elevation' ) {
        let ret = null;
        if ( type == 'elevation' ) {
            ret = new Cesium.Material({
                fabric: {
                    type: 'ElevationColorContour',
                    materials: {
                        contourMaterial: {
                            type: 'ElevationContour'
                        },
                        elevationRampMaterial: {
                            type: 'ElevationRamp'
                        }
                    },
                    components: {
                        diffuse: 'contourMaterial.alpha == 0.0 ? elevationRampMaterial.diffuse : contourMaterial.diffuse',
                        alpha: 'max(contourMaterial.alpha, elevationRampMaterial.alpha)'
                    }
                },
                translucent: false
            });
        } else
        if ( type == 'slope' ) {
            ret = new Cesium.Material({
                fabric: {
                    type: 'SlopeColorContour',
                    materials: {
                        contourMaterial: {
                            type: 'ElevationContour'
                        },
                        slopeRampMaterial: {
                            type: 'SlopeRamp'
                        }
                    },
                    components: {
                        diffuse: 'contourMaterial.alpha == 0.0 ? slopeRampMaterial.diffuse : contourMaterial.diffuse',
                        alpha: 'max(contourMaterial.alpha, slopeRampMaterial.alpha)'
                    }
                },
                translucent: false
            });
        } else

        if ( type == 'aspect' ) {
            ret = new Cesium.Material({
                fabric: {
                    type: "AspectColorContour",
                    materials: {
                        contourMaterial: {
                        type: "ElevationContour",
                    },
                    aspectRampMaterial: {
                        type: "AspectRamp",
                    },
                    },
                    components: {
                        diffuse: "contourMaterial.alpha == 0.0 ? aspectRampMaterial.diffuse : contourMaterial.diffuse",
                        alpha: "max(contourMaterial.alpha, aspectRampMaterial.alpha)",
                    },
                },
                translucent: false
            });
        }
        // console.log ( 'get_CONTOUR_Material', type, ret );
        return ret;
    }

    /*
    exploreObject ( obj:any ) {
        // console.log ( '!!!!!!!!!!!!!!!!!! exploreObject() START', obj );
        if ( obj._root ) {
            this.exploreTile ( obj._root );
            this.exploreNode ( obj._root );
        }
        // console.log ( '!!!!!!!!!!!!!!!!!! exploreObject() END', this.tiles, this.nodes );
    }

    tiles:any = {};
    nodeCache:any = {};
    nodes:any = [];

    exploreNode ( obj:any ) {
        // console.log ( '--- exploreNode()' );
        if ( obj._header && obj._header.content && obj._header.content.uri ) {
            let uri = obj._header.content.uri;
            if ( ! this.nodeCache[uri] ) {
                this.nodeCache[uri] = true;
                this.nodes.push({
                    uri: uri,
                    state: obj['_contentState'],
                    hasContent: obj['_content'] ? true : false,
                });
                if ( obj.children ) {
                    obj.children.forEach ( child => {
                        this.exploreNode ( child );
                    });
                }
            }
        }
    }

    exploreTile ( obj:any ) {
        
        let c = obj._content;
        let r = c ? c['_resource'] : null;
        let url = r ? r['_url'] : null;
        let pick = r ? c['_pickId']: null;
        let color = pick ? pick['color']: null;

        // console.log ( '--- exploreTile()', url, c?c:false, r?r:false, pick?pick:false,color?color:false );


        if ( url ) {

            if ( ! this.tiles[url] ) {
                this.tiles[url] = {
                    object: obj,
                    features: obj._features,
                    z: obj._centerZDepth,
                    color: color,
                    length: obj._content.pointsLength,
                    pointCloud:null,
                    pointCloudRender:null
                };

                if ( c._pointCloud ) {
                    this.tiles[url]['pointCloud'] = c._pointCloud;
                    if ( c._pointCloud._drawCommand ) {
                        this.tiles[url]['pointCloudRender'] = c._pointCloud._drawCommand['_shaderProgram']['_vertexShaderText'];
                    }
                }

                if ( obj.children ) {
                    obj.children.forEach ( child => {
                        this.exploreTile ( child );
                    });
                }
            }

        }
    }
    */

    getNamedProps() {
        var tileProperties = this.object._properties;
        var nameMinAndMax=[];
       
        if (Cesium.defined(tileProperties)) {
            for (var props in tileProperties) {
               if (Cesium.defined(tileProperties[props].minimum)){
                   nameMinAndMax.push([props,tileProperties[props].minimum,tileProperties[props].maximum]);
               }
            }
        }
    // console.log('----- getting props -----', this.object, tileProperties, nameMinAndMax ) ;

    return nameMinAndMax;
    }

    getMinMaxFor ( selected:string ) {
        
        let nameMinAndMax = this.getNamedProps();

         //assuming that user has selected the 'Height' property for styling:
        // find the min/max using the selsetedAttribute
    
        var min=999999,max=0;
       
        for (var i=0;i<nameMinAndMax.length;i++){
            
            if (selected===nameMinAndMax[i][0]) {
                min=nameMinAndMax[i][1];
                max=nameMinAndMax[i][2];
            }
        }

    // console.log('!! minMax()', selected, nameMinAndMax, min, max );

        return { min:min, max:max };
    }

    resetHeight() {
        this.getObjectMinMax();
        this.refresh();
    }

    getObjectMinMax() {
        let happy:boolean = false;
        if ( this.object._properties && this.object._properties.Height ) {
            if ( this.debug ) { console.log ( '%c colorize.plugin %c getObjectMinMax() found height property', this.debugPrimary, this.debugSecondary, this.object.properties ); }
            let t = this.object._properties.Height;
            if ( t.minimum && t.maximum ) {
                this.controls.min.value = Math.round(t.minimum);
                this.controls.max.value = Math.round(t.maximum);
                this.setModelMinMax();
                happy = true;
            }
        }
        return happy;
    }

    // MetersToDecimalDegrees(meters, latitude) {
    //     return meters / (111.32 * 1000 * Math.cos(latitude * (Math.PI / 180)));
    // }

    sampleHeight() {

        let happy:boolean = false;

        if ( this.object && this.object.boundingSphere ) {

            const coordCart = this.object.boundingSphere.center;

            let coord = new CoordGeodetic( this.globe.ellipsoid.cartesianToCartographic(coordCart) );
            let cesiumCoord = coord.toCesiumCartographic();

            let meter =  0.0000001;

            let t = null;
            let positions = [];
            let samples = [];

            const divs = 50;
            const radius = this.object.boundingSphere.radius;
            const total_meters = radius * 2;
            const grid = Math.round( total_meters / divs);
        
            let step = meter * grid;
            let offset = radius * meter;

            // console.log ( '%c @@@@@@@@@ divs=['+divs+'] radius=['+radius+'] meters=['+total_meters+'] grid=['+grid+'] one_meter=['+meter+'] step=['+step+']', Constants._blue, offset );

            if ( divs > 100 ) {
                // console.log ( '%c @@@@@@@@@ ABORT', Constants._blue );
                return null;
            }


            // console.log ( '%c @@@@@@@@@ FROM,TO', Constants._blue, coord, cesiumCoord, cesiumCoord.longitude - offset, cesiumCoord.longitude + ( step * divs ) );

            cesiumCoord.longitude = cesiumCoord.longitude - offset;
            cesiumCoord.latitude = cesiumCoord.latitude - offset;

            let min = 99999;
            let max = -99999;
            let heights:number[] = [];

            for ( let n=0; n<divs; n++ ) {
                t = this.viewer.scene.sampleHeight(cesiumCoord);
                heights.push(t);
                // if ( t && Math.round(t) != 0 ) {
                    positions.push ( cesiumCoord.clone() );
                    if ( t > max ) { max = t; }
                    if ( t < min ) { min = t; }
                // } else {
                //     samples.push( cesiumCoord.clone() );
                // }
                cesiumCoord.longitude = cesiumCoord.longitude + step;
                cesiumCoord.latitude = cesiumCoord.latitude + step;
            }

            const pos = _.cloneDeep ( positions );

            var promise = this.viewer.scene.sampleHeightMostDetailed(pos);
            promise.then(function(updatedPosition) {
                // positions[0].height and positions[1].height have been updated.
                // updatedPositions is just a reference to positions.
                // console.log ( '@@@ BEAM promised=', updatedPosition );
            });

            // console.log ( '@@@ BEAM promising=', min, max, positions, heights );

            this.splatPositions(samples, 'miss.png').then ( _ => {

                this.splatPositions(positions).then ( _ => {

                    // console.log ( '%c colorize.plugin %c sampleHeight() SPLAT done', this.debugPrimary, this.debugSecondary );
                    
                });
            });
            
            if ( min < 9999 && max > -9999 ) {
                happy = true;
                this.controls.min.value = Math.round(min);
                this.controls.max.value = Math.round(max);
                this.setModelMinMax(false);
                this.refresh();

                // console.log ( '%c colorize.plugin %c sampleHeight() found averages', this.debugPrimary, this.debugSecondary, min, this.controls.min.value, max, this.controls.max.value, positions.length );
            }
            
        }
        return happy;
    }

    splatPositions( positions, icon:string = 'hit.png' ) {

        let promise = new Promise ( resolve => {
        
            let n = 0;
            let samples = [];

            positions.forEach( p => {

                let newc = new CoordGeodetic(p, true);
                if ( ! newc.height ) {
                    newc.height = 40;
                }
                this.coordHelper.updateCartesian(newc);

                let e = this.viewer.entities.add ( {
                    position: newc.toCesiumCartesian(),
                    billboard: {
                        image: 'assets/images/icons/' + icon,
                        disableDepthTestDistance:1500,
                        scale:2,
                    }
                });

                samples.push(e);

                n++;

            });

            this.entity ( 'samples-'+icon, samples );

            const total = 15;
            const fact = 2 / total;
            for ( let n=1; n<=total; n++ ) {
                setTimeout ( () => {
                    let q = this.entity('samples-'+icon);
                    if ( q ) {
                        q.forEach( e => {
                            e.billboard.scale = 2 - ( n * fact );
                        });
                    }
                    if ( n == total ) {
                        this.wipeEntity('samples-'+icon);
                        resolve(null);
                    }
                }, n * 250 );    
            }

        });
        return promise;
    }

    /*
    listProperties() {
        let ret = [];
        if ( this.type == ColorizingHandler.PointcloudType ) {
            ret = this.findAllProperties(this.object);
        } else {
            ret.push('none');
            let props = this.item['__properties'];
            if ( props ) {
                Object.keys(props).forEach( key => {
                    const p = props[key];
                    if ( p.number || p.string ) {
                        ret.push(key); //  + ' ('+this.propertyLength(p,this.propertyType(p))+')');
                    }
                });
            }
        }
        this.controls.property.options = ret;
        // return ret;
    }
    */

    /* findAllProperties( e:any ) {

        this.properties.delete;
        this.properties = ['none'];

        if ( e._properties ) {
            Object.keys(e._properties).forEach(key => {
                this.properties.push(key); //.slice(1);
            });
            // console.log('@@properties *****************************************************', e, e._properties, this.properties );
        }
        return this.properties;
    } */

    updatePropertyNames() {

        // this.__log ('updatePropertyNames() await...');
        // console.log ( '%c colorize.plugin %c updatePropertyNames() await', this.debugPrimary, this.debugSecondary, this.object, this.props );
        
        let me = this;

        XsAwait.until( ['object','streamedPropertyStore','properties'], this ).then ( _ => {

            // me.__log ('updatePropertyNames() await DONE', [ me.props, me.propertyStore ] );

            me.controls.property.options = [ 'none', ...me.properties.getPropertyNames(me.object) ];
            me.controls.property.advancedOptions = [ { value:'none' }, ...me.properties.getPropertyNamesObj(me.object, me.streamedPropertyStore) ];

            // console.log('@@properties *****************************************************', me.object, me.properties );

        });

        

    }

    configProperty ( propertyKey:string ) {                

        this.updatePropertyNames();

        if ( this.type == ColorizingHandler.PointcloudType ) {
            // this.controls.property.options = this.findAllProperties(this.object);
            
        } else {
            // let props = this.item['__properties'];

            let prop = this.streamedPropertyStore.getProperty(propertyKey);

            if ( prop ) {
                
                this.controls.propertyType.value = this.streamedPropertyStore.propertyType(prop);
                this.controls.propertyLength.value = this.streamedPropertyStore.propertyLength(prop,this.controls.propertyType.value);
                this.controls.propertyLength.options = this.streamedPropertyStore.propertyMap(prop,this.controls.propertyType.value);

                this.controls.propertyInfo.options = this.controls.propertyLength.options;
                this.controls.propertyInfo.value = this.controls.propertyLength.value + ' unique '+this.controls.propertyType.value+' values';
                
            // } else {
            //     this.controls.propertyType.value = '--';
            //     console.log('!!!!! properties error', propertyKey, props );
            }            
        }

        // console.log ( '%c colorize.plugin %c configProperty()', this.debugPrimary, this.debugSecondary, this.type, this.props.getPropertyNames(this.object), this.controls.property.options, this.propertyStore );

    }
}






export interface DialogData {
    text: string;
    name: string;
    title:string;
    content: any[];
    properties: any;
    map: any;
    plugin: any;
    colorManager: any;
    negBtn: any;
}


@Component({
    selector: 'controller-config-dialog',
    templateUrl: 'colormap-controller.html',
})
export class ColormapDialog {

    loading:boolean = false;

    property:string = null;
    properties:number = 0;
    map:any = [];

    plugin:any = null;

    palette:any = null;

    pickValue:any;
    pickColor:string = '';

    section:any = { value: 'default', name: 'Colors', type:'select', options: [ 'none' ], optionType:'colors', colorbar:true, topSpace:true };



    sortTypeOptions:string[] = [ 'normal','natural' ];
    sortOrderOptions:string[] = [ 'ascending','descending' ];

    sortingByType:string = null;
    sortingByOrder:string = null;


    sortByType ( $event ) {

    }
    sortByOrder ( $event ) {

    }

    showColors:boolean = false;
    toggleShowColors() {
        this.showColors = !this.showColors;
    }

    showPicker:boolean = false;
    toggleShowPicker() {
        this.showPicker = !this.showPicker;
    }

    showSelect:boolean = false;
    toggleShowSelect( value:any = null, section:any = null ) {
        this.showSelect = !this.showSelect;
        if ( value && section ) {
            section.value = value;
        }
        if ( this.plugin ) {
            this.palette = this.plugin.linearScalePalette(this.section.value);
        }
    }

    constructor(
        public dialogRef: MatDialogRef<ColormapDialog>,
        @Inject(MAT_DIALOG_DATA) public data: DialogData) {
            if ( this.data.plugin ) {
                this.plugin = this.data.plugin;
            }
            if ( this.plugin && this.plugin.controls && this.plugin.controls.kind ) {
                this.section = this.plugin.controls.kind;
                this.property = this.plugin.controls.property.value;
                this.map = this.data.map;
                this.properties = Object.keys(this.map).length;
            }
            // this.section.options = this.data.colorManager.listColorPalettes();
            this.init();
        }
        
    uuidv4() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

    originalOrder = (a: KeyValue<number,string>, b: KeyValue<number,string>): number => {
        return 0;
    }

    init() {
        this.palette = this.plugin.linearScalePalette(this.section.value);
    }

    colorize() {
        let colors = this.plugin.services.colorManager.idxObjectPickEvery( this.palette, { items: this.properties });
        // console.log("###COLORIZE", this.palette, this.properties, colors );
        let idx = 0;
        Object.keys(this.map).forEach ( key => {
            this.map[key].color = this.plugin.services.colorManager.hexRgb ( colors[idx] );
            // console.log("###COLORIZE idx=", idx, colors[idx], this.map[key] );
            idx++;
        });
    }

    pick ( idx:number, p:any) {
        this.toggleShowPicker();
        this.pickValue = p;
    }

    picked ( value, section ) {
        // this.toggleShowPicker();
        // console.log('@@picked', value, section );
        this.pickValue.color = ''+value;
    }

    picking ( value, section ) {
        // console.log('@@picking', value, section );
    }

    onCancelClick(): void {
        this.dialogRef.close(false);
    }

    onSaveClick(): void {
        this.data.map = this.map;
        this.dialogRef.close(this.data);
    }

}